export default {"src":"/_next/static/media/ico_excla3.1a8b1fe4.svg","height":17,"width":20,"blurWidth":0,"blurHeight":0};